import { z } from "zod";

/**
 * Что формы принимают до отправки.
 *
 * Правила здесь **зеркалят серверные**, а не заводят свои: длины берутся из
 * таблицы `LIMITS` в `@shared/config`, а её сверяет с исходниками сервера
 * `scripts/check-form-rules.mjs` на каждом `npm run check`.
 *
 * Чего здесь нет и не будет: правил, которых на сервере нет. Формат хэндла,
 * годность кода приглашения, занятость почты — это знает сервер и только он,
 * а угадывать его ответ значит однажды отказать в том, что он бы принял.
 */

/**
 * Необязательная строка с потолком.
 *
 * Пустая строка проходит: у этих полей «пусто» — законное значение, оно
 * означает «стереть», и сервер принимает его как `null`. Приводить его к
 * `null` здесь нельзя — это делает отправка, и делает по-разному: у профиля
 * стирается, у темы канала тоже, а у имени пустого не бывает вовсе.
 */
export const optional = (max: number) =>
  z.string().max(max, `Не длиннее ${max} знаков`);

/** Обязательная строка: пустую сервер не примет, и незачем его спрашивать. */
export const required = (min: number, max: number, blank: string) =>
  z.string().trim().min(min, blank).max(max, `Не длиннее ${max} знаков`);
